import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext'; // Import AuthContext
import LoadingSpinner from './common/LoadingSpinner'; // Import LoadingSpinner
import { Navigate, useLocation } from "react-router-dom";

/**
 * Protects routes so only users with role 'business_admin' (or 'super_admin') can access.
 * Redirects others to the home page or login.
 */
const RequireBusinessAdmin = ({ children }) => {
  const { isAuthenticated, loadingAuth, hasPermission,user } = useContext(AuthContext);
  const location = useLocation();
  console.log("RequireBusinessAdmin: user:", user, "loading:", loadingAuth);

  if (loadingAuth) {
    // Show a global loading spinner while authentication status is being checked
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <LoadingSpinner />
      </div>
    );
  }

  // If not authenticated, redirect to login page
  if (!isAuthenticated) {
    // Use Navigate component to declaratively redirect
    // Pass current location to login page so it can redirect back after successful login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!user) {
    // Not logged in, redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.role !== "business_admin" && user.role !== "super_admin") {
    // Not a business admin, redirect to dashboard or 404
    return <Navigate to="/dashboard" replace />;
  }

  // Authorized
  return children;
};

export default RequireBusinessAdmin;